export enum MFA_METHOD {
    SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
    SMS_MFA = 'SMS_MFA'
}

